import { validatePresence } from 'ember-changeset-validations/validators';
import validateCoachingReportSectionFieldValues from '../../validators/coaching-report-section-field-values';

export default function ({ individual }) {
  return {
    startDate: validatePresence(true),
    endDate: validatePresence(true),
    sectionFieldValues: [
      validateCoachingReportSectionFieldValues({ individual }),
    ],
  };
}
